var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrLogo = function SvgBrLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#0157FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3985 15.0205C18.1716 14.7962 17.9128 14.6037 17.6298 14.4488C17.7278 14.3547 17.8188 14.254 17.9019 14.1476C18.3684 13.5379 18.5925 12.7882 18.5336 12.0339C18.4848 11.2454 18.1397 10.5005 17.5623 9.93741C16.89 9.31145 15.982 8.97379 15.0457 9.00159H11.8V20.9976H15.6257C16.6233 21.0332 17.5924 20.674 18.306 20.0041C19.0196 19.3341 19.415 18.4123 19.3996 17.4544C19.412 16.5485 19.0524 15.6742 18.3985 15.0205ZM15.046 10.4006C16.3629 10.4006 17.0124 11.2678 17.072 12.1273C17.1175 13.0137 16.4584 13.7901 15.5445 13.9265H13.2583V10.4006H15.046ZM13.2583 19.5986H15.62H15.626C17.2309 19.5986 17.9479 18.4875 17.9479 17.4544C17.9479 16.4672 17.2865 15.3236 15.4154 15.3236H13.2583V19.5986Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "BR_logo.fcc187858d3a56fa5e38704821d1094b.svg";